module.exports = __webpack_public_path__ + "static/media/thumbnail.c279c896.jpg";